import {h, Fragment} from "preact"
import Product from "./Product"
import ProductPlaceholder from "./ProductPlaceholder"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    useEffect(() => {
      if (!loading && products?.hits?.length) {
          requestAnimationFrame(() => {
              if (window.Shopify?.market?.reinitialize) {
                console.log("[Products] Calling Shopify.market.reinitialize()")
                window.Shopify.market.reinitialize()
              } else {
                console.warn("[Products] Shopify.market.reinitialize not available")
              }

              if (window.Nosto?.migrateToShopifyMarket) {                
                window.Shopify?.market?.reinitialize?.();
                window.Nosto.migrateToShopifyMarket({
                  productSectionElement: ".nosto-product-info",
                  productUrlElement: ".nosto-product-url",
                  productHandleAttribute: "x-nosto-handle",
                  priceElement: ".nosto-newprice.money",
                  listPriceElement: ".nosto-oldprice.money",
                })
              } else {
                console.warn("[Products] Nosto.migrateToShopifyMarket not available")
              }
          })
      }
  }, [products?.hits?.length, loading])

    const placeholderList = [...Array(8)].map((card, index) => (
        <ProductPlaceholder key={index} />
      ));     

    return (
    <div className="product-grid-large relative z-10" id="ProductGridContainer">
        <ul id="product-grid" role="list">
            {products.hits.map((hit, index) => {
                return <Product product={hit} index={index} key={hit.productId || index} />
            })}
        </ul>
    </div>
    )
}
